konnyScript(function ($) {
	// Tab Slide
	var tabNavSlide = new Swiper("#tab_nav_swiper_slide", {
		slidesPerView: 'auto',
		grabCursor: true,
		centeredSlides: false,
	});

	// Tab Scroll
	(function () {
		const $tabs = $('.eventWrap .navWrap li');
		const sections = [...Array($tabs.length)].map((_, i) => $('#tabCon' + (i + 1)));
		const isMobile = () => $(window).width() <= 750;

		let isFromClick = false;
		let scrollWatcher;

		$('#tab_nav_swiper_slide a').on('click', function (e) {
			e.preventDefault();
			const $li = $(this).closest('li');
			const index = $li.index();

			$li.addClass('on').siblings().removeClass('on');
			tabNavSlide.slideTo(index);

			const headerHeight = $('#header').outerHeight() || 0;
			const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
			const fixHeight = headerHeight + navHeight;
			const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top) || (window.innerWidth <= 749 ? 60 : 68);

			const targetSection = $('#tabCon' + (index + 1));

			if (targetSection.length) {
				const targetTop = targetSection.offset().top - fixHeight - fixedTop;

				isFromClick = true;
				let startScrollTop = $(window).scrollTop();

				window.scrollTo({
					top: targetTop,
					behavior: 'smooth'
				});

				cancelAnimationFrame(scrollWatcher);
				function watchScroll() {
					const current = $(window).scrollTop();
					if (Math.abs(current - targetTop) < 3) {
						isFromClick = false;
						return;
					}
					scrollWatcher = requestAnimationFrame(watchScroll);
				}
				watchScroll();
			}

			if (isMobile()) {
				const container = tabNavSlide.el;
				const containerWidth = $(container).width();
				const wrapper = $(container).find('.swiper-wrapper');
				const slideOffset = $li.position().left;
				const slideWidth = $li.outerWidth(true);
				const totalTabs = $tabs.length;

				let scrollX = 0;

				if (totalTabs <= 3) {
					scrollX = 0;
				} else {
					scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
					const last = $tabs.last();
					const maxScrollX = last.position().left + last.outerWidth(true) - containerWidth;
					scrollX = Math.max(0, Math.min(scrollX, maxScrollX));
				}

				wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
			}
		});

		$(window).on('load scroll', function () {
			if (!$('.eventWrap .navWrap').length || isFromClick) return;

			const headerHeight = $('#header').outerHeight() || 0;
			const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
			const fixHeight = headerHeight + navHeight;
			const winTop = $(window).scrollTop();
			const bwNavTop = $('.eventWrap .navArea').offset().top - navHeight;

			let activeIndex = 0;
			const ACTIVATION_OFFSET = -150;
			for (let i = sections.length - 1; i >= 0; i--) {
				if (winTop > sections[i].offset().top - fixHeight + ACTIVATION_OFFSET) {
					activeIndex = i;
					break;
				}
			}

			if (winTop > bwNavTop) {
				$('.eventWrap .navWrap').addClass('fixed');
			} else {
				$('.eventWrap .navWrap').removeClass('fixed');
			}

			const $activeTab = $tabs.eq(activeIndex);
			$activeTab.addClass('on').siblings().removeClass('on');
			tabNavSlide.slideTo(activeIndex);

			if (isMobile()) {
				const container = tabNavSlide.el;
				const containerWidth = $(container).width();
				const wrapper = $(container).find('.swiper-wrapper');
				const slideOffset = $activeTab.position().left;
				const slideWidth = $activeTab.outerWidth(true);
				const totalTabs = $tabs.length;

				let scrollX = 0;

				if (totalTabs <= 3) {
					scrollX = 0;
				} else {
					scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
					const last = $tabs.last();
					const maxScrollX = last.position().left + last.outerWidth(true) - containerWidth;
					scrollX = Math.max(0, Math.min(scrollX, maxScrollX));
				}

				wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
			}
		});
	})();
});